import React from 'react';
import classnames from 'classnames';

import Label from 'shared/components/Label';
import Tooltip from 'shared/components/Tooltip';
import SelectInput from 'shared/components/SelectInput';

const SelectComponent = (props) => {
  const {
    label,
    required,
    name,
    tooltip,
    errorMessage,
    inputClassName,
    className,
    inputId,
  } = props;

  return (
    <div className={classnames('form-group', className)}>
      <Label htmlFor={inputId} label={label} required={required}>
        <Tooltip id={`tooltip-${name}`} title={tooltip} />
      </Label>
      <SelectInput {...props} className={inputClassName}/>
      <span className="error">
        {errorMessage}
      </span>
    </div>
  );
};

SelectComponent.defaultProps = {
  label: '',
  required: false,
  tooltip: '',
};

export default SelectComponent;
